import { useDispatch } from 'react-redux';

import { sendVerificationEmail } from 'actions/user';
import Button from 'atoms/button';
import { DefaultAvatar } from 'atoms/default-avatar';
import toast from 'atoms/toast';
import { prettifyPhoneNumber } from 'util';

export default function UserDetails({ data }) {
  const dispatch = useDispatch();
  const { user, animal } = data;

  const onResendVerififactionEmail = async () => {
    const emailSent = await dispatch(sendVerificationEmail(user.uuid));
    if (emailSent.success) {
      toast({ text: 'A verification email has been sent to this user' });
    }
  };

  return (
    <div className="p-24 border-light-purple radius-24">
      <div className="flex-row align-start">
        <DefaultAvatar
          size="small"
          avatar={user.links?.image?.desktop?.small}
        />
        <div className="ml-8">
          <p className="bold f13">{user.firstName}</p>
          <p className="f11">
            {animal.type.map((type) => type.value).join(', ')}
          </p>
          {user.phone && (
            <p className="f11">
              {prettifyPhoneNumber({
                number: user.phone.number,
                countryCode: user.phone.country?.code.value,
              })}
            </p>
          )}
          <p className="f11">{user.email}</p>
        </div>
      </div>
      {!user.mfaVerified && (
        <Button
          text="Resend verification email"
          size="small"
          variant="white-outlined"
          className="mt-10 fw-400"
          onClick={onResendVerififactionEmail}
        />
      )}
    </div>
  );
}
